// src/hooks/useSubjects.ts
import { useEffect, useState } from "react";
import axios from "axios";

export interface Subject {
  id: string;
  name: string;
  terms: string[];
}

export const useSubjects = (grade: string, term: string) => {
  const [subjects, setSubjects] = useState<Subject[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchSubjects = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`/api/subjects?grade=${grade}&term=${term}`);
        setSubjects(response.data);
        setError(null);
      } catch (err) {
        setError('Failed to fetch subjects');
        console.error('Error fetching subjects:', err);
      } finally {
        setLoading(false);
      }
    };

    if (grade && term) {
      fetchSubjects();
    }
  }, [grade, term]);

  return { subjects, loading, error };
};

export default useSubjects;
